import angular from "angular";
import { cloneDeep } from "lodash";

angular
    .module('ui-sentinel.alarms')
    .directive('alarmSubscribers', AlarmSubscribersDirective);

function AlarmSubscribersDirective() {
    const directive = {
        restrict: 'A',
        controller: ThisDirectiveController,
        controllerAs: 'alarmSubscribers',
        template: require('./alarm-subscribers-directive.html'),
        link: link
    };
    return directive;

    function link(scope, element, attrs, controller) {
        scope.$watch(
            function (scope) {
                return scope.alarmAdmin.alarm;
            },
            function (newValue, oldValue) {
                controller.alarm = newValue;
            }, true
        );
    }
}

ThisDirectiveController.$inject = ['$rootScope', '$state', 'AlarmsService', 'AlarmContactsService', 'FeedbackService', 'SentinelUiSession'];

function ThisDirectiveController($rootScope, $state, AlarmsService, AlarmContactsService, FeedbackService, SentinelUiSession) {
    const vm = {
        alarm: null,
        isOrs: $rootScope.isOrs,
        orsHideButtons: $rootScope.isOrs && !SentinelUiSession.user.isAnAdmin,
        contacts: {
            assigned: [],
            available: [],
            removable: []
        },
        actions: {
            beginAdd: beginAdd,
            endAdd: endAdd,
            add: add,
            beginRemove: beginRemove,
            endRemove: endRemove,
            remove: remove,
            goToContact: goToContact,
            reload: load
        },
        mode: {
            isAdding: false,
            isRemoving: false
        },
        panel: {
            isCollapsed: true,
            toggle: function () {
                this.isCollapsed = !this.isCollapsed;
                if (!this.isCollapsed) {
                    load();
                }
            }
        },
        feedback: FeedbackService,
        hasPermission: {
            toChange: false
        },
        formatSmsString: AlarmContactsService.formatSmsString
    };
    activate();
    return vm;

    function activate() {
        setPermissions();
    }

    function add(contact) {
        $rootScope.loading = true;
        vm.feedback.clear();

        const promise = AlarmsService.addSubscriber(vm.alarm, contact).$promise;
        promise.then(
            function (result) {
                vm.contacts.assigned = result;
                contact.isAdded = true;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function beginAdd() {
        vm.mode.isAdding = true;
        vm.contacts.available = [];

        const promise = AlarmContactsService.getContacts(SentinelUiSession.focus).$promise;
        promise.then(
            function (result) {
                const available = [];
                _.forEach(result, function (contact) {
                    let isAdded = false;
                    _.forEach(vm.contacts.assigned, function (addedContact) {
                        if (addedContact.contactId === contact.contactId) {
                            isAdded = true;
                            return false;
                        }
                    });
                    available.push(angular.extend(contact, { isAdded: isAdded }));
                });

                vm.contacts.available = available;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function endAdd() {
        vm.mode.isAdding = false;
        vm.contacts.available = [];
        load();
    }

    function beginRemove() {
        vm.mode.isRemoving = true;
        vm.contacts.removable = [];

        const removable = [];
        _.forEach(vm.contacts.assigned, function (contact) {
            removable.push(angular.extend(contact, { isRemoved: false }));
        });

        vm.contacts.removable = removable;
    }

    function endRemove() {
        vm.mode.isRemoving = false;
        vm.contacts.removable = [];
        load();
    }

    function goToContact(contact) {
        const returnState = $state.current.name;
        const returnStateParams = cloneDeep($state.params);
        $state.go('alarmcontact.admin', {
            contactId: contact.contactId,
            referrer: returnState,
            referrerParams: returnStateParams
        });
    }

    function remove(contact) {
        $rootScope.loading = true;
        vm.feedback.clear();

        const promise = AlarmsService.removeSubscriber(vm.alarm, contact).$promise;
        promise.then(
            function (result) {
                vm.contacts.assigned = result;
                contact.isRemoved = true;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function load() {
        $rootScope.loading = true;
        vm.contacts.assigned = [];
        const promise = AlarmsService.getSubscribers(vm.alarm).$promise;
        promise.then(
            function (result) {
                vm.contacts.assigned = result;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function setPermissions() {
        vm.hasPermission.toChange =
            SentinelUiSession.user.isSystemAdmin ||
            SentinelUiSession.user.isAccountAdmin ||
            SentinelUiSession.user.isAccountEditor;
    }
}
